import { NgModule } from "@angular/core";
import { HaUiNavigationModule } from "@ha/ui/navigation";
import { NgxsFormPluginModule } from "@ngxs/form-plugin";

import { SharedModule } from "../shared/shared.module";
import { moduleTranslationProviderFactory } from "../translation/scope-loader";
import { PersonalNumberComponent } from "./personal-number.component";

@NgModule({
    imports: [
        SharedModule,
        NgxsFormPluginModule,
        HaUiNavigationModule,
    ],
    exports: [PersonalNumberComponent],
    declarations: [PersonalNumberComponent],
    providers: [
        moduleTranslationProviderFactory("PersonalNumber")
    ],
})
export class PersonalNumberModule {}
